import React, { useMemo } from 'react';
import styles from './DiscourseAttachments.module.scss';
import DekurzAttachment from '../../../../Components/Dekurz/DekurzAttachment';
import { useDiscourseContext } from '../../Services/DiscourseContext';
import { NOT_ALLOWED_ATTACHMENTS } from '../../Enums/discourseDocumentItemType.const';

interface Props {
	patientId: string;
	virtualPatientId: string;
}

const DiscourseAttachments: React.FC<Props> = ({
	patientId,
	virtualPatientId,
}) => {
	const { removeAttachmentFromDiscourse, discourseAttachments } =
		useDiscourseContext();

	const attachments = useMemo(() => {
		return discourseAttachments?.filter(
			(item: any) => !NOT_ALLOWED_ATTACHMENTS.some(type => type === item.type),
		);
	}, [discourseAttachments]);

	return (
		<div className={styles.wrapper}>
			{attachments?.map((item: any) => (
				<DekurzAttachment
					patientId={patientId}
					virtualPatientId={virtualPatientId}
					item={item}
					key={item.id}
					onRemoveAttachment={() => removeAttachmentFromDiscourse(item.id)}
				/>
			))}
		</div>
	);
};

export default DiscourseAttachments;
